import { showSnackbar } from "utils/snack_bar/store/action";
import { executeMutation, executeQuery } from "utils/services/apiServices";
import { FETCH_ALL_SPECIAL_OFFERS } from "../graphql/query";
import { actionTypes, CreateSpecialOfferInput, SpecialOfferProps } from "./actionType";
import { CREATE_SPECIAL_OFFER, UPDATE_SPECIAL_OFFER } from "../graphql/mutation";

export const featchSpecialOfferRequest = () => ({
  type: actionTypes.FETCH_SPECIAL_OFFER_REQUEST,
});

export const featchSpecialOfferSuccess = (payload: SpecialOfferProps[]) => ({
  type: actionTypes.FETCH_SPECIAL_OFFER_SUCCESS,
  payload,
});

export const featchSpecialOfferFail = (payload: string) => ({
  type: actionTypes.FETCH_SPECIAL_OFFER_FAIL,
  payload,
});

export const featchSpecialOffer = () => {
  return async (dispatch: any) => {
    try {
      await dispatch(featchSpecialOfferRequest());
      const response = await executeQuery(FETCH_ALL_SPECIAL_OFFERS);
      const jsonData = response.data?.fetchAllSpecialOffer;
      if (jsonData?.error === null) {
        dispatch(featchSpecialOfferSuccess(jsonData?.data.special_offers));
      } else {
        dispatch(featchSpecialOfferFail(jsonData?.error.message));
      }
    } catch (error: any) {
      dispatch(featchSpecialOfferFail("Failed to fetch"));
    }
  };
};

export const createSpecialOfferRequest = () => ({
  type: actionTypes.CREATE_SPECIAL_OFFER_REQUEST,
});

export const createSpecialOfferSuccess = (payload: SpecialOfferProps) => ({
  type: actionTypes.CREATE_SPECIAL_OFFER_SUCCESS,
  payload,
});
export const createSpecialOfferFail = (payload: string) => ({
  type: actionTypes.CREATE_SPECIAL_OFFER_FAIL,
  payload,
});
export const createSpecialOffer = (input: CreateSpecialOfferInput) => {
  return async (dispatch: any) => {
    try {

      await dispatch(createSpecialOfferRequest());
      const response = await executeMutation(CREATE_SPECIAL_OFFER, {input});
      const jsonData = response.data?.createSpecialOffer;

      if (jsonData?.error === null) {
        dispatch(createSpecialOfferSuccess(jsonData?.data.special_offer));
        dispatch(showSnackbar("Success! featured ads created."));
      } else {
        dispatch(createSpecialOfferFail(jsonData?.error.message));
        dispatch(showSnackbar(`${jsonData.error ? jsonData.error : "Fail to create."}`));
      }
    } catch (error: any) {
      dispatch(createSpecialOfferFail("Something went wrong, Try again later"));
    }
  };
};
export const updateSpecialOfferRequest = () => ({
  type: actionTypes.UPDATE_SPECIAL_OFFER_REQUEST,
});

export const updateSpecialOfferSuccess = (payload: SpecialOfferProps) => ({
  type: actionTypes.UPDATE_SPECIAL_OFFER_SUCCESS,
  payload,
});
export const updateSpecialOfferFail = (payload: string) => ({
  type: actionTypes.UPDATE_SPECIAL_OFFER_FAIL,
  payload,
});
export const updateSpecialOffer = (input: CreateSpecialOfferInput, special_offer_id: string) => {
  return async (dispatch: any) => {
    try {
      const inputData = {
        input: input,
        special_offer_id: special_offer_id,
      };
      await dispatch(updateSpecialOfferRequest());
      const response = await executeMutation(UPDATE_SPECIAL_OFFER, inputData);
      const jsonData = response.data?.updateSpecialOffer;
      if (jsonData?.error === null) {
        dispatch(updateSpecialOfferSuccess(jsonData?.data.special_offer));
        dispatch(showSnackbar("Success! Special offer updated."));
      } else {
        dispatch(updateSpecialOfferFail(jsonData?.error.message));
        dispatch(showSnackbar(`${jsonData.error ? jsonData.error : "Fail to update."}`));
      }
    } catch (error: any) {
      dispatch(updateSpecialOfferFail("Something went wrong, Try again later"));
    }
  };
};
export const uploadSpecialOfferVideoRequest = () => ({
  type: actionTypes.UPLOAD_SPECIAL_OFFER_VIDEO_REQUEST,
});

//RESET
export const ResetSpecialOffer = () => ({
  type: actionTypes.RESET_SPECIAL_OFFER,
});

export const resetSpecialOffer = () => {
  return async (dispatch: any) => {
    dispatch(ResetSpecialOffer());
  };
};

